import { Component, Renderer2, ElementRef } from '@angular/core';
export class TdDataTableRowComponent {
/**
 * @param {?} _elementRef
 * @param {?} _renderer
 */
constructor(private _elementRef: ElementRef,
private _renderer: Renderer2) {
    this._renderer.addClass(this._elementRef.nativeElement, 'td-data-table-row');
  }
/**
 * @return {?}
 */
focus(): void {
    this._elementRef.nativeElement.focus();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  moduleId: module.id,
  /* tslint:disable-next-line */
  selector: 'tr[td-data-table-row]',
  styleUrls: ['./data-table-row.component.css' ],
  templateUrl: './data-table-row.component.html',
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: Renderer2, },
];
}

function TdDataTableRowComponent_tsickle_Closure_declarations() {
/** @type {?} */
TdDataTableRowComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdDataTableRowComponent.ctorParameters;
/** @type {?} */
TdDataTableRowComponent.prototype._elementRef;
/** @type {?} */
TdDataTableRowComponent.prototype._renderer;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
